export { default as StarsRadioButtonsItem } from './StarsRadioButtonsItem';
